import { fetchFromObject } from 'helpers/object';

export default {
  getOperationDataField: state => field => fetchFromObject(state, field),

  getCompanyAttorneyList: state => {
    const array = state.prospect.contact;
    const arrayAttorneyList = array.slice('1', array.length);
    return arrayAttorneyList;
  }
};
